<template>
  <div class="report-detail-page">
    <!-- Loading state -->
    <div v-if="loading" class="d-flex justify-center align-center pa-8">
      <v-progress-circular
        indeterminate
        color="primary"
        size="48"
      ></v-progress-circular>
    </div>

    <!-- Error state -->
    <div v-else-if="error" class="pa-4">
      <v-alert type="error" variant="tonal">
        {{ error }}
        <template #append>
          <v-btn variant="tonal" color="error" @click="refetch">
            <v-icon start>mdi-refresh</v-icon>
            Opnieuw proberen
          </v-btn>
        </template>
      </v-alert>
    </div>

    <!-- Main content -->
    <div v-else-if="report && account" class="report-detail-container">
      <!-- Account context header -->
      <AccountListItem :account="account" :detail="false" class="mb-4" />

      <!-- Comments section with report card -->
      <CommentBox
        :id="report.id"
        type="Report"
        :report="report"
        :show-report-actions="true"
      />
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount } from "vue";
import { useRoute } from "vue-router";
import { useReportsStoreRefactor } from "@/stores/reportsStoreRefactor";
import { useAccountsStoreRefactor } from "@/stores/accountsStoreRefactor";
import { useMenuStore } from "@/stores/menuStore";
import { useAutoFetchReport } from "@/composables/useAutoFetch";

import CommentBox from "../comments/CommentBox.vue";
import AccountListItem from "../accounts/AccountListItem.vue";

const route = useRoute();
const menuStore = useMenuStore();
const reportsStore = useReportsStoreRefactor();
const accountsStore = useAccountsStoreRefactor();

// Auto-fetch report and account data reactively
const reportId = computed(() => route.params.id);
const { report, account, loading, error, refetch } = useAutoFetchReport(
  reportsStore,
  accountsStore,
  reportId,
);

// Setup on mount
onMounted(() => {
  menuStore.setBackActive(true);
});

// Clean up when leaving the page
onBeforeUnmount(() => {
  menuStore.setBackActive(false);
});
</script>
